<div *ngIf="alwaysVisible || !isValid" class="ft2-checklist-container">
    <p class="ft2-checklist-title" *ngIf="title">
        {{title}}
    </p>
    <p class="mb-3" *ngIf="summary" [innerHTML]="summary">
    </p>
    <ul class="ft2-checklist">
        <ng-container *ngFor="let rule of rules">
            <li *ngIf="alwaysVisible || !rule.isValid">
                <span class="ft2-checklist_status" [class.-valid]="activeFormGroup?.controls?.[rule?.formControlName]?.valid || rule.isValid">
                </span>
                {{rule.text}}
            </li>
        </ng-container>
    </ul>
</div>
